import React, { memo } from 'react';
import { IPartner } from '../../../model/partner';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Button from 'global/react-mui/atoms/Button';
import TopPartner from '../../TopPartner';
import { useStyles } from './styles';
import { uiSliceActions } from '../../../store/modules/ui/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { fhwSliceActions } from '../../../store/modules/fhw/reducer';
import { translationsSelector } from '../../../store/modules/translations/selectors';
import { mapSliceActions } from '../../../store/modules/map/reducer';
import { focussedPartnerIdSelector } from '../../../store/modules/fhw/selectors';
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { iconPaths } from '../../../../../../../../global/react/constants/icons';
import Certificate from '../../Certificate/Certificate';


const PartnerCard: React.FC<{ partner: IPartner; }> = ({
	partner: { name, nameAdditional, address, id, image, isCertified, isTopPartner },
	...props
}) => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const { partnersListViewProfileButtonText, certifiedTitle, topPartnerTitle } = useSelector(translationsSelector);
	const focussedPartnerId = useSelector(focussedPartnerIdSelector)

	const isFocussed = focussedPartnerId === id

	const openIndividualProfileDrawer = () => {

		dispatch(fhwSliceActions.setSelectedPartner(`${id}`));
		setTimeout(() => {
			dispatch(uiSliceActions.setIsIndividualProfileDrawerOpen({ isOpen: true }));
		}, 900)

	};

	const setCurrentPositionOnMapCenter = () => {
		dispatch(mapSliceActions.setMapCentre({ lat: address.lat, lng: address.lng }));
		dispatch(fhwSliceActions.setFocussedPartnerId(id));
		dispatch(mapSliceActions.setMapZoom(14));
	};

	const mainClass = `${!isCertified && !isTopPartner ? classes.partners : ''} ${isCertified && !isTopPartner ? classes.certificate : ''} ${isTopPartner && !isCertified ? classes.partner : ''} ${isCertified && isTopPartner ? classes.partnersCertified : ''}`

	return (
		<Card className={clsx(classes.root, {
			[classes.isFocussed]: isFocussed,
		})} onClick={setCurrentPositionOnMapCenter} {...props}>

			{image ?
				<CardMedia className={classes.cover} image={image} title={name} />
				:
				<SvgIcon viewBox={"0 0 33 32"} className={classes.companyReplacementIcon}>
					<path d={iconPaths.worker} />
				</SvgIcon>
			}

			<div className={classes.details}>
				<CardContent className={classes.content}>
					<Typography component="h4" variant="h4" className={classes.companyName}>
						{name}
					</Typography>
					<Typography variant="body1" color="textSecondary">
						{nameAdditional}
					</Typography>
					<Typography variant="body1" color="textSecondary">
						{`${address.address1} ${address.address2} ${address.address3}`}
					</Typography>
					<Typography variant="body1" color="textSecondary">
						{`${address.postcode} ${address.city}`}
					</Typography>
				</CardContent>
			</div>
			<Box className={mainClass} height={130} >
				{isCertified && <span className={classes.certificateBadge}><Certificate title={certifiedTitle} /></span>}
				{isTopPartner && <span className={classes.partnerBadge}><TopPartner title={topPartnerTitle} /></span>}
			</Box>
			<Button onClick={openIndividualProfileDrawer} variant="outlined" className={classes.roundedButton}>
				{partnersListViewProfileButtonText}
			</Button>
		</Card>
	);
};

export default memo(PartnerCard);



